import { useEffect, useState } from "react";
import React from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "../../API";
import "./Categories.css"; // Custom CSS for further styling

const SocomAdvisor = () => {
    const [advisors, setadvisors] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const res = await axios.get(`${API}/api/advisor/website/active`, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
                console.log(res.data)
                setadvisors(res.data?.data);
            } catch (error) {
                console.error("Error fetching Channel:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);
    const generateSlug = (name) => {
        // return name.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");
        return name
            .toLowerCase()
            .trim()                         // 🔥 remove leading/trailing spaces first
            .replace(/\s+/g, "-")
            .replace(/[^a-z0-9-]/g, "")
            .replace(/-+/g, "-")            // optional: collapse multiple -
            .replace(/^-|-$/g, "");         // 🔥 remove starting & ending -

    };
    const dummyAdvisors = [
        {
            name: "Rahul Sharma",
            image: "https://res.cloudinary.com/dytknkefn/image/upload/v1768892262/users/profilePicture/mryeohnmnf6h2ob8utzt.jpg",
        },
        {
            name: "Amit Verma",
            image: "https://res.cloudinary.com/dytknkefn/image/upload/v1768892262/users/profilePicture/mryeohnmnf6h2ob8utzt.jpg",
        },
        {
            name: "Sandeep Kumar",
            image: "https://res.cloudinary.com/dytknkefn/image/upload/v1768892262/users/profilePicture/mryeohnmnf6h2ob8utzt.jpg",
        },
        {
            name: "Vikram Singh",
            image: "https://res.cloudinary.com/dytknkefn/image/upload/v1768892262/users/profilePicture/mryeohnmnf6h2ob8utzt.jpg",
        },
    ];



    return (
        <div className="category-home">
            {
                loading ? (
                    <div className="loading-indicator" >
                        <div className="dot"></div>
                        <div className="dot"></div>
                        <div className="dot"></div>
                    </div>) : advisors?.length !== 0 && (
                        <>
                            <h5 className="category-title">Explore SoCom Advisors</h5>

                            {/* Cards Slider */}
                            <div className="category-grid">
                                {advisors.map((item, index) => {

                                    const linkUrl = advisors?.length
                                        ? `/apex_channel/${generateSlug(item.name)}`
                                        : "#";

                                    return (
                                        <Link
                                            to={linkUrl}
                                            
                                            className="category-link"
                                            key={index}
                                        >
                                            <div
                                                className="category-card position-relative text-center"
                                                style={{ position: "relative" }}
                                            >
                                                <img
                                                    // src="https://res.cloudinary.com/dytknkefn/image/upload/v1768892262/users/profilePicture/mryeohnmnf6h2ob8utzt.jpg"
                                                    src={item?.thumbnail?.url}

                                                    alt={item?.name || "advisor"}
                                                    className="category-thumbnail"

                                                />

                                                {/* NAME OVER IMAGE */}
                                                {/* <div
                                                    className="advisor-name-overlay"
                                                    style={{
                                                        position: "absolute",
                                                        bottom: "10px",
                                                        left: "50%",
                                                        transform: "translateX(-50%)",
                                                        background: "rgba(0, 0, 0, 0.6)",
                                                        color: "#fff",
                                                        padding: "6px 12px",
                                                        borderRadius: "6px",
                                                        fontSize: "14px",
                                                        fontWeight: "600",
                                                        zIndex: 10,
                                                        whiteSpace: "nowrap"
                                                    }}
                                                >
                                                    {item?.name}
                                                </div> */}
                                                <div className="category-name">
                                                    <span title={item.name}>{item.name}</span>
                                                </div>
                                            </div>
                                        </Link>

                                    );
                                })}
                            </div>


                        </>
                    )}
        </div>

    );
};

export default SocomAdvisor;

